import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Autonumeric from "autonumeric";

export default class extends Controller {
  static values = { timeout: Number }
  static targets = [
    "modal", "saveBtn"
  ];

  connect() {
    this.initTriggerSubmit();
    this.selectProjectTemplate();
    if (this.shouldOpenModal()) {
      this.openModal();
    }
    this.initializeControls();
    this.initializeInputs();
    this.startValidationMonitor();
    this.scrollToErrorMonitor();
    this.initializeAddButtons();

    const locale = document.documentElement.lang
    if (locale) {
      window.Parsley.setLocale(locale);
    }
  }

  initTriggerSubmit() {
    if (this.hasSaveBtnTarget) {
      const triggerSubmit = this.saveBtnTarget.dataset.triggerSubmit
      if (triggerSubmit === "true") {
        setTimeout(() => {
          this.saveBtnTarget.click();
        }, 10);
      }
    }
  }

  selectProjectTemplate() {
    if (window.location.search.includes('select_template_id')) {
      let templateId = new URLSearchParams(window.location.search).get('select_template_id');
      let base_url = window.location.pathname;
      let input = document.querySelector("#booking_brand_id_" + templateId);
      let project_templates_count = document.querySelectorAll('.booking__chooseProjectItem').length || 0;

      if (window.location.pathname.includes('cart')) {
        let url = base_url.replace('project_details', 'select_brand.js?brand_id=' + templateId);
        if (project_templates_count > 1) {
          $.ajax({ url });
          if (input) {
            input.checked = true;
          }
        }
      } else {
        let url = base_url.replace('edit', 'select_brand.js?brand_id=' + templateId);
        if (project_templates_count > 1) {
          $.ajax({ url });
          if (input) {
            input.checked = true;
          }
        }
      }

      window.history.replaceState(null, '', (url => (url.searchParams.delete('select_template_id'), url.href))(new URL(window.location.href)));
      $('#your-project')?.trigger('click')
    }
  }

  shouldOpenModal() {
    return window.location.search.includes('modal_form=show');
  }

  openModal() {
    if (this.hasModalTarget && this.modalTarget.getAttribute('id') !== 'modal__ai_project_template_create') {
      $("#" + this.modalTarget.getAttribute('id')).modal("show")
      let FirstSection = document.querySelector('.section.collapse')
      FirstSection?.classList.add("show");
    }

    setTimeout(function() {
      window.history.replaceState(null, '', (url => (url.searchParams.delete('modal_form'), url.href))(new URL(window.location.href)));
    },0);
  }

  initializeAddButtons() {
    const addButtons = document.querySelectorAll('[data-modal-target]');
    const sectionWrapperBlocks = document.querySelectorAll('.accordion-section-wrapper');
    addButtons.forEach((button) => {
      button.addEventListener("click", () => {
        sectionWrapperBlocks.forEach(sectionWrapper => {
          let sectionBlock = sectionWrapper.children[0]
          sectionWrapper.classList.add('collapsed');
          sectionBlock.classList.remove('show');
          sectionBlock.classList.remove('collapsed');
        })
        if (document.querySelector(button.dataset.modalTarget)) {
          let currentSectionWrapper = document.querySelector(button.dataset.modalTarget)?.closest(".accordion-section-wrapper");
          let currentSection = document.querySelector(button.dataset.modalTarget)?.closest(".section");
          let currentField = document.querySelector(button.dataset.modalTarget)?.closest(".field");
          if (currentSectionWrapper !== null) {
            currentSectionWrapper?.classList.remove("collapsed");
            currentSectionWrapper?.classList.add("show");
            currentSectionWrapper?.children[0].classList.remove('collapsed');
          }
          if (currentSection !== null) {
            currentSection?.classList.add("show");
          }

          if (currentField !== null && button.dataset.scrollOn === "true") {
            setTimeout(function () {
              currentField.scrollIntoView({behavior: 'smooth', block: 'start'})
            }, 400);
          }

          if (currentSectionWrapper !== null && currentField !== null) {
            setTimeout(function () {
              const sectionNames = ["brands", "concept", "product_service", "social_media"];

              if (sectionNames.includes(button.dataset.scroll)) {
                currentSectionWrapper?.scrollIntoView({behavior: 'smooth', block: 'start'});
              } else {
                currentField?.scrollIntoView({behavior: 'smooth', block: 'start'})
              }
            }, 400);
          }
        }
      });
    });
  }

  initializeControls() {
    const saveButtons = document.querySelectorAll('#' + this.element.id + ' .submit-btn');
    saveButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.saveProjectTemplate();
      });
    });
  }

  initializeInputs() {
    const input = document.querySelector('input.select-text');
    if (input !== null) {
      input.addEventListener("click", () => {
        input.focus();
        input.select();
      });
    }
    $('[data-toggle="tooltip"]').tooltip();
  }

  updateSectionIndicator(section) {
    function validateImageResolution(logoUploaderId, width, height) {
      return new Promise((resolve, reject) => {
        const logoUploaderDiv = document.getElementById(logoUploaderId)?.querySelector('.preview');

        if (logoUploaderDiv.classList.contains('empty')) {
          resolve(false);
          return;
        }
        if (logoUploaderDiv) {
          const computedStyle = window.getComputedStyle(logoUploaderDiv);

          const backgroundImageUrl = computedStyle.getPropertyValue('background-image');

          if (backgroundImageUrl && backgroundImageUrl === 'url("")') {
            resolve(true);
            return;
          }

          const decodedUrl = decodeURIComponent(backgroundImageUrl.replace(/url\("(.+?)"\)/, '$1'));
          const img = new Image();
          img.src = decodedUrl;

          img.onload = function() {
            resolve(this.width >= width && this.height >= height);
          };

          img.onerror = () => {
            resolve(false);
          };
        }
      });
    }

    function validateDirectImageResolution(image, width, height) {
      return new Promise((resolve, reject) => {
        if (!image || typeof image.getAttribute !== 'function') {
          return resolve(false);
        }
        const decodedUrl = decodeURIComponent(image.getAttribute('src')?.replace(/url\("(.+?)"\)/, '$1'));
        const img = new Image();
        img.src = decodedUrl;

        img.onload = function() {
          resolve(this.width >= width && this.height >= height);
        };

        img.onerror = () => {
          resolve(false);
        };
      });
    }

    function validateURL(urlString) {
      if (urlString && !/^https?:\/\//i.test(urlString)) {
        urlString = 'https://' + urlString;
      }

      const URL_REGEX = /^((https?):\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;

      const match = urlString.match(URL_REGEX);
      return urlString.includes(' ') ? false : match && match[0].length <= 200;
    }

    const validatedInputs = Array.from(section.querySelectorAll('[data-validate="true"]'));
      const validationsPromises = validatedInputs.map(input => {
          if (input.name === 'project_template[description]') {
              if (window.location.pathname.includes('booking') || window.location.pathname.includes('cart')) {
                  const modal = input.closest('.modal');
                  if (modal) {
                      const descriptionErrorField = modal.querySelector('#project_template_description_error');
                      const descriptionErrorFieldMessage = descriptionErrorField.dataset.errorLength;
                      const isValid = input.value.length >= 200;

                      if (!isValid) {
                          if (descriptionErrorField.classList.contains('is-hidden')) {
                              descriptionErrorField.classList.remove('is-hidden');
                          }
                          if (descriptionErrorField.innerText !== descriptionErrorFieldMessage) {
                              descriptionErrorField.innerText = descriptionErrorFieldMessage;
                          }
                          input.classList.add('input__danger');
                      } else {
                          if (!descriptionErrorField.classList.contains('is-hidden')) {
                              descriptionErrorField.classList.add('is-hidden');
                              input.classList.remove('input__danger');
                          }
                      }
                      return isValid;
                  }
              }
          }
      if (input.name === 'project_template[website]') {
        if (input.attributes['data-required']?.value === 'false') {
          return input.value === "" ? true : validateURL(input.value);
        }
        else {
          return validateURL(input.value);
        }
      }
      if (input.name === 'project_template[instagram_id]') {
        if (input.attributes['data-required']?.value === 'false') {
          return input.value === "" ? true : validateURL(input.value);
        }
        else {
          return validateURL(input.value);
        }
      }
      if (input.name === 'project_template[linkedin_id]') {
        if (input.attributes['data-required']?.value === 'false') {
          return input.value === "" ? true : validateURL(input.value);
        }
        else {
          return validateURL(input.value);
        }
      }
      if (input.name === 'project_template[facebook_id]') {
        if (input.attributes['data-required']?.value === 'false') {
          return input.value === "" ? true : validateURL(input.value);
        }
        else {
          return validateURL(input.value);
        }
      }
      if (input.name === 'project_template[twitter_id]') {
        if (input.attributes['data-required']?.value === 'false') {
          return input.value === "" ? true : validateURL(input.value);
        }
        else {
          return validateURL(input.value);
        }
      }
      if (input.name === 'project_template[year_founded]') {
        return (input.value.length >= 4);
      }
      if (input.name === 'project_template[title]') {
        return (input.value.length > 0 && input.value.length < 255);
      }
      if (input.name === 'project_template[name]') {
        return (input.value.length > 0 && input.value.length < 255);
      }
      if (input.name === 'project_template[based]') {
        return (input.value.length > 0 && input.value.length < 255);
      }
      if (input.name === 'project_template[brand_documents]') {
        let documentsParentElement = document.querySelector('#project_template_brand_documents').parentElement
        let documents = documentsParentElement.querySelector('#attachment_files .template-download')

        if (input.attributes['data-required']?.value === 'false' && !documents) {
          return true;
        }
        else {
          const filesInputWrapper = input.closest('#project_template_files');
          if (!filesInputWrapper) return Promise.resolve(false);

          const filesImageWrapper = filesInputWrapper.querySelectorAll('.template-download');
          if (filesImageWrapper.length < 1) return Promise.resolve(false);

          const validationPromises = Array.from(filesImageWrapper).map(file_wrapper => {
            const image = file_wrapper.querySelector('img');
            return validateDirectImageResolution(image, 600, 600);
          });

          return Promise.all(validationPromises).then(results => results.every(Boolean));
        }
      }
      if (input.name === 'project_template[brand_images]') {
        let imagesParentElement = document.querySelector('#project_template_brand_images').parentElement
        let images = imagesParentElement.querySelector('#attachment_files .template-download')

        if (input.attributes['data-required']?.value === 'false' && !images) {
          return true;
        }
        else {
          const photosInputWrapper = input.closest('#product_services_section');
          if (!photosInputWrapper) return Promise.resolve(false);

          const photosImageWrapper = photosInputWrapper.querySelectorAll('.template-download');
          if (photosImageWrapper.length < 1) return Promise.resolve(false);

          const validationPromises = Array.from(photosImageWrapper).map(photo_wrapper => {
            const image = photo_wrapper.querySelector('img');
            return validateDirectImageResolution(image, 600, 600);
          });

          return Promise.all(validationPromises).then(results => results.every(Boolean));
        }
      }
      if (input.name === 'project_template[overall_look]') {
        const minLength = input.rows > 3 ? 200 : 4;
        const isValid = input.value.length >= minLength;

        if ((window.location.pathname.includes('booking') || window.location.pathname.includes('cart')) && input.closest('.modal')) {
          const modal = input.closest('.modal');
          const overallLookErrorField = modal.querySelector('#project_template_overall_look_error');
          if (overallLookErrorField) {
            const errorMessage = overallLookErrorField.dataset.errorLength;

            if (!isValid) {
              overallLookErrorField.classList.remove('is-hidden');
              overallLookErrorField.innerHTML = errorMessage;
              input.classList.add('input__danger');
            } else {
              overallLookErrorField.classList.add('is-hidden');
              input.classList.remove('input__danger');
            }
          }
        }

        return isValid;
      }
      if (input.name === 'project_template[shops_experience]') {
        const inputElement = document.querySelector('#' + this.element.id + ' .active input[name="project_template[shops_experience]"]')?.value;
        return (document.querySelector('#' + this.element.id + ' #project_template_shops_experience')?.type === "text" ?
            document.querySelector('#' + this.element.id + ' #project_template_shops_experience').value.length >= 4 :
            (inputElement === 'true' || inputElement === 'false'));
      }
      if (input.name === 'project_template[existing_shops_info]') {
        return (input.value.length >= 4);
      }
      if (input.name === 'project_template[popups_experience]') {
        const inputElement = document.querySelector('#' + this.element.id + ' .active input[name="project_template[popups_experience]"]')?.value;
        return (document.querySelector('#' + this.element.id + ' #project_template_popups_experience')?.type === "text" ?
            document.querySelector('#' + this.element.id + ' #project_template_popups_experience').value.length >= 4 :
            (inputElement === 'true' || inputElement === 'false'));
      }
      if (input.name === 'project_template[prices_from]') {
        let pricesTo = document.querySelector('#' + this.element.id + ' #project_template_prices_to')?.value;
        let pricesToValue = pricesTo !== '' ? parseInt(pricesTo?.replace(/[.,]/g, '').match(/\d+/)[0]) : '';
        if (input.value !== '' && input.value !== null && pricesToValue !== '') {
        let pricesFrom = parseInt(input.value?.replace(/[.,]/g, '').match(/\d+/)[0]);
          return (pricesFrom >= 0 && pricesToValue >= (pricesFrom));
        }
      }
      if (input.name === 'project_template[prices_to]') {
        let pricesFrom = document.querySelector('#' + this.element.id + ' #project_template_prices_from')?.value;
        let pricesFromValue = pricesFrom !== '' ? parseInt(pricesFrom?.replace(/[.,]/g, '').match(/\d+/)[0]) : '';
        if (input.value !== '' && input.value !== null && pricesFromValue !== '') {
          let pricesTo = parseInt(input.value?.replace(/[.,]/g, '').match(/\d+/)[0]);
          return (pricesTo >= pricesFromValue && pricesTo !== 0);
        }
      }
      if (input.name === 'project_template[tags][]') {
        if (input.attributes['data-required']?.value === 'true') {
            let parentTags = document.getElementById('project_template_tags').parentElement
            let tagsAnySelected = parentTags.querySelectorAll('.select2-selection__choice');

            return tagsAnySelected.length > 0
        } else {
          return true;
        }
      }
      if (input.name === 'project_template[industry][]') {
        if (input.attributes['data-required']?.value === 'true') {
          let parentIndustry = document.getElementById('project_template_industry').parentElement
          let industryAnySelected = parentIndustry.querySelectorAll('.select2-selection__choice');

          return industryAnySelected.length > 0
        } else {
          return true;
        }
      }
      if (input.name === `brand[logo-${input.dataset.projectTemplateId}]`) {
        if (input.attributes['data-required']?.value === 'true') {
          let logoSelector = `#logo-fileupload-brand-logo-${input.dataset.projectTemplateId} .preview`;
          const previewElement = document.querySelector(logoSelector);
          if (previewElement?.classList.contains('empty')) {
            return false;
          }
        }
        if (document.querySelector('#' + this.element.id + ' .save-btn')?.attributes["data-form-name"].nodeValue !== 'full_new_ai') {
          return validateImageResolution(`logo-fileupload-brand-logo-${input.dataset['projectTemplateId']}`, 600, 600);
        } else {
          return true;
        }
      }
      if (input.name === `brand[image-${input.dataset.projectTemplateId}]`) {
        if (input.attributes['data-required']?.value === 'true') {
          let imageSelector = `#logo-fileupload-brand-image-${input.dataset.projectTemplateId} .preview`;
          let previewElement = document.querySelector(imageSelector);
          if (previewElement?.classList.contains('empty')) {
            return false;
          }
        }
        if (document.querySelector('#' + this.element.id + ' .save-btn')?.attributes["data-form-name"].nodeValue !== 'full_new_ai') {
          return validateImageResolution(`logo-fileupload-brand-image-${input.dataset['projectTemplateId']}`, 1200, 800);
        } else {
          return true;
        }
      }
      return !!input.value;
    });

    Promise.all(validationsPromises).then(results => {
      const filled = results.every(result => result);
      const errorFields = Array.from(section.querySelectorAll('.input__error'));
      validatedInputs.forEach((input, index) => {
        const errorField = errorFields.find(field => (field.id) === `${input.id.replace(/(_true|_false)$/, '').replace(/brand\[(.*?)]/, 'project_template_$1')}_error`);
        if (errorField) {
          if (results[index]) {
            errorField.innerHTML = "";
            errorField.classList.add("is-hidden");
            const markDangerElements = errorField?.parentElement.querySelectorAll('.input, .select2-selection--single, .select2-selection--multiple');
            markDangerElements?.forEach(el => el.classList.remove('input__danger'));
          }
        }
      });
      const sectionHeader = document.querySelector('#' + this.element.id + ` .section__header[data-target="#${section.getAttribute("id")}"]`);
      if (filled && sectionHeader) {
        section.querySelectorAll('#' + this.element.id + ' .input__error').forEach((errorHolder) => {
          errorHolder.innerHTML = "";
          errorHolder.classList.add("is-hidden");
          const markDangerElements = errorHolder?.parentElement.querySelectorAll('.input, .select2-selection--single, .select2-selection--multiple');
          markDangerElements?.forEach(el => el.classList.remove('input__danger'));
        });
        sectionHeader.classList.remove("invalid");
        sectionHeader.classList.add("filled");
      } else if (sectionHeader) {
        sectionHeader.classList.remove("filled");
      }
    });
  }

  startValidationMonitor() {
    const that = this;
    this.validationTimer = setInterval(() => {
      document
          .querySelectorAll('#' + this.element.id + ' .section')
          .forEach((section) => {
            that.updateSectionIndicator(section);
          });

      let instagramUrlInput = document.getElementById('instagram_url')
      let photosLength = document.querySelectorAll('#product_services_section .template-download').length
      let instagramHolder = document.getElementById('instagram_photos_holder');
      if (instagramUrlInput != null) {
        if (photosLength > 0) {
          instagramUrlInput.closest('.field').style.display = 'none';
        }
        if (photosLength === 0) {
          instagramUrlInput.closest('.field').style.display = '';
          instagramHolder.parentElement.classList.add('d-none');
        }
      }
    }, 300);
  }

  scrollToErrorMonitor() {
    const submitButton = document.getElementById('submit-inquiry');

    submitButton?.addEventListener('click', function (e) {
      setTimeout(function () {
        let error = document.querySelector('ul.parsley-errors-list.filled');

        if (error) {
          error.closest('.section-block').scrollIntoView({behavior: 'smooth'});
        }
      }, 100);
    });
  };

  saveProjectTemplate() {
    event.preventDefault();
    const form = document.querySelector('#' + this.element.id + ' #project_template_form');
    const method = form.getAttribute("data-method");
    const action = form.getAttribute("data-action");
    const formName = event.target.attributes["data-form-name"].nodeValue;

    let dataToSend = {};

    let tagsArray = document.querySelectorAll('#' + this.element.id + ' .project_template_tags option');
    let selectedTags = [];
    tagsArray.forEach(tag => {
      if (tag['selected']) {
        selectedTags.push(tag.value);
      }
    });
    selectedTags = selectedTags.length ? selectedTags : [""];

    let industryArray = document.querySelectorAll('#' + this.element.id + ' .project_template_industry option');
    let selectedIndustry = [];
    industryArray.forEach(industry => {
      if (industry['selected']) {
        selectedIndustry.push(industry.value);
      }
    });
    selectedIndustry = selectedIndustry.length ? selectedIndustry : [""];

    if (formName === "brands") {
      let website = document.querySelector('#' + this.element.id + ' #project_template_website').value;

      if (website && !/^https?:\/\//i.test(website)) {
        website = 'https://' + website;
      }

      dataToSend = {
        name: document.querySelector('#' + this.element.id + ' #project_template_name').value,
        tags: selectedTags,
        title: document.querySelector('#' + this.element.id + ' #project_template_title').value,
        description: document.querySelector('#' + this.element.id + ' #project_template_description').value,
        employee_count: document.querySelector('#' + this.element.id + ' #project_template_employee_count').value,
        year_founded: document.querySelector('#' + this.element.id + ' #project_template_year_founded').value,
        based: document.querySelector('#' + this.element.id + ' #project_template_based').value,
        website: website,
      };
    } else if (formName === "concepts") {
      dataToSend = {
        industry: selectedIndustry,
        overall_look: document.querySelector('#' + this.element.id + ' #project_template_overall_look').value.replace(/(\r\n|\n|\r)/gm, " "),
        shops_experience: document.querySelector('#' + this.element.id + ' #project_template_shops_experience')?.type === "text" ?
                          document.querySelector('#' + this.element.id + ' #project_template_shops_experience').value :
                          document.querySelector('.active input[name="project_template[shops_experience]"]')?.value,
        existing_shops_info: document.querySelector('#' + this.element.id + ' #project_template_existing_shops_info').value,
        popups_experience: document.querySelector('#' + this.element.id + ' #project_template_popups_experience')?.type === "text" ?
            document.querySelector('#' + this.element.id + ' #project_template_popups_experience').value :
            document.querySelector('#' + this.element.id + ' .active input[name="project_template[popups_experience]"]')?.value
      };
    } else if (formName === "product_services") {
      let pricesFromValue = document.querySelector('#' + this.element.id + ' #project_template_prices_from')?.value
      let pricesToValue = document.querySelector('#' + this.element.id + ' #project_template_prices_to')?.value
      dataToSend = {
        prices_from: pricesFromValue !== '' ? parseInt(pricesFromValue?.replace(/[.,]/g, '').match(/\d+/)[0].slice(0, 7)) : NaN,
        prices_to: pricesToValue !== '' ? parseInt(pricesToValue?.replace(/[.,]/g, '').match(/\d+/)[0].slice(0, 7)) : NaN,
      };
    } else if (formName === "social_media") {
      let instagram = document.querySelector('#' + this.element.id + ' #project_template_instagram_id').value;
      if (instagram && !/^https?:\/\//i.test(instagram)) {
        instagram = 'https://' + instagram;
      }

      let linkedin = document.querySelector('#' + this.element.id + ' #project_template_linkedin_id').value;
      if (linkedin && !/^https?:\/\//i.test(linkedin)) {
        linkedin = 'https://' + linkedin;
      }

      let facebook = document.querySelector('#' + this.element.id + ' #project_template_facebook_id').value;
      if (facebook && !/^https?:\/\//i.test(facebook)) {
        facebook = 'https://' + facebook;
      }

      let twitter = document.querySelector('#' + this.element.id + ' #project_template_twitter_id').value;
      if (twitter && !/^https?:\/\//i.test(twitter)) {
        twitter = 'https://' + twitter;
      }

      dataToSend = {
        instagram_id: instagram,
        linkedin_id: linkedin,
        facebook_id: facebook,
        twitter_id: twitter,
      };
    } else if (formName === "unit") {
      dataToSend = {
        unit_id: document.querySelector('#' + this.element.id + ' #project_template_unit_id').value,
      }
    } else if (formName === "instagram_photos") {
        let instagram = document.querySelector('#' + this.element.id + ' #instagram_url').value;
        let instagramErrorHolder = document.querySelector('#project_template_instagram_url_error');
        if (instagram && !/^https?:\/\//i.test(instagram)) {
            instagram = 'https://' + instagram;
        }

        if (instagram === "" || !instagram.includes('instagram.com')) {
          instagramErrorHolder.innerHTML = instagramErrorHolder.getAttribute('data-error-text')
          instagramErrorHolder.classList.remove("is-hidden");
        }

        else {
          instagramErrorHolder.innerHTML = ""
          instagramErrorHolder.classList.add("is-hidden");
          instagramErrorHolder.parentElement.querySelector('.input')?.classList.remove("input__danger");
          if (document.querySelector('#project_template_guest_token')?.value) {
            dataToSend = {
              guest_token: document.querySelector('#project_template_guest_token')?.value,
              instagram_id: instagram,
            };
          }
          else {
            dataToSend = {
              instagram_id: instagram,
            };
          }
        }
    } else if (formName === "active") {
      dataToSend = {
        is_active: document.querySelector('#' + this.element.id + ' #set_active').checked,
      }
    } else if (formName === "partial_new" || formName === "partial_new_ai") {
      let tenant_qualification = document.querySelector('#' + this.element.id + ' #tenant_qualification')?.value;
      let website = document.querySelector('#' + this.element.id + ' #project_template_website')?.value;

      if (website && !/^https?:\/\//i.test(website)) {
        website = 'https://' + website;
      }

      dataToSend = {
        guest_token: document.querySelector('#project_template_guest_token').value,
        title: document.querySelector('#' + this.element.id + ' #project_template_title').value &&
            document.querySelector('#' + this.element.id + ' #project_template_title').value,
        tenant_qualification: tenant_qualification,
        website: website,
        name: document.querySelector('#' + this.element.id + ' #project_template_name')?.value,
        tags: selectedTags,
        industry: selectedIndustry,
        overall_look: document.querySelector('#' + this.element.id + ' #project_template_overall_look')?.value.replace(/(\r\n|\n|\r)/gm, " ")
      };
    } else if (formName === "partial_pull_data_ai") {
      let instagram = document.querySelector('#' + this.element.id + ' #project_template_instagram_id')?.value;
      if (instagram && !/^https?:\/\//i.test(instagram)) {
        instagram = 'https://' + instagram;
      }

      let tenant_qualification = document.querySelector('#' + this.element.id + ' #tenant_qualification')?.value;
      let website = document.querySelector('#' + this.element.id + ' #project_template_website')?.value;

      if (website && !/^https?:\/\//i.test(website)) {
        website = 'https://' + website;
      }

      dataToSend = {
        guest_token: document.querySelector('#project_template_guest_token').value,
        title: document.querySelector('#' + this.element.id + ' #project_template_title')?.value,
        tenant_qualification: tenant_qualification,
        website: website,
        instagram_id: instagram,
        name: document.querySelector('#' + this.element.id + ' #project_template_name')?.value,
        tags: selectedTags,
        industry: selectedIndustry,
        overall_look: document.querySelector('#' + this.element.id + ' #project_template_overall_look')?.value.replace(/(\r\n|\n|\r)/gm, " ")
      };
    } else {
      let website = document.querySelector('#' + this.element.id + ' #project_template_website')?.value;

      if (website && !/^https?:\/\//i.test(website)) {
        website = 'https://' + website;
      }

      let instagram = document.querySelector('#' + this.element.id + ' #project_template_instagram_id')?.value;
      if (instagram && !/^https?:\/\//i.test(instagram)) {
        instagram = 'https://' + instagram;
      }

      let linkedin = document.querySelector('#' + this.element.id + ' #project_template_linkedin_id')?.value;
      if (linkedin && !/^https?:\/\//i.test(linkedin)) {
        linkedin = 'https://' + linkedin;
      }

      let facebook = document.querySelector('#' + this.element.id + ' #project_template_facebook_id')?.value;
      if (facebook && !/^https?:\/\//i.test(facebook)) {
        facebook = 'https://' + facebook;
      }

      let twitter = document.querySelector('#' + this.element.id + ' #project_template_twitter_id')?.value;
      if (twitter && !/^https?:\/\//i.test(twitter)) {
        twitter = 'https://' + twitter;
      }

      let pricesFromValue = document.querySelector('#' + this.element.id + ' #project_template_prices_from')?.value
      let pricesToValue = document.querySelector('#' + this.element.id + ' #project_template_prices_to')?.value

      if (pricesFromValue && pricesToValue || pricesFromValue === '' && pricesToValue === '') {
        dataToSend = {
          guest_token: document.querySelector('#project_template_guest_token').value,
          name: document.querySelector('#' + this.element.id + ' #project_template_name')?.value,
          tags: selectedTags,
          title: document.querySelector('#' + this.element.id + ' #project_template_title')?.value,
          description: document.querySelector('#' + this.element.id + ' #project_template_description')?.value,
          employee_count: document.querySelector('#' + this.element.id + ' #project_template_employee_count')?.value,
          year_founded: document.querySelector('#' + this.element.id + ' #project_template_year_founded')?.value,
          based: document.querySelector('#' + this.element.id + ' #project_template_based')?.value,
          website: website,
          form_name: event.target.attributes["data-form-name"].nodeValue,
          overall_look: document.querySelector('#' + this.element.id + ' #project_template_overall_look')?.value.replace(/(\r\n|\n|\r)/gm, " "),
          shops_experience: document.querySelector('#' + this.element.id + ' #project_template_shops_experience')?.type === "text" ?
              document.querySelector('#' + this.element.id + ' #project_template_shops_experience')?.value :
              document.querySelector('#' + this.element.id + ' .active input[name="project_template[shops_experience]"]')?.value,
          existing_shops_info: document.querySelector('#' + this.element.id + ' #project_template_existing_shops_info')?.value,
          popups_experience: document.querySelector('#' + this.element.id + ' #project_template_popups_experience')?.type === "text" ?
              document.querySelector('#' + this.element.id + ' #project_template_popups_experience')?.value :
              document.querySelector('#' + this.element.id + ' .active input[name="project_template[popups_experience]"]')?.value,
          industry: selectedIndustry,
          prices_from: pricesFromValue !== '' ? parseInt(pricesFromValue?.replace(/[.,]/g, '').match(/\d+/)[0].slice(0, 7)) : NaN,
          prices_to: pricesToValue !== '' ? parseInt(pricesToValue?.replace(/[.,]/g, '').match(/\d+/)[0].slice(0, 7)) : NaN,
          instagram_id: instagram,
          linkedin_id: linkedin,
          facebook_id: facebook,
          twitter_id: twitter,
          unit_id: document.querySelector('#' + this.element.id + ' #project_template_unit_id')?.value,
        };
      }
      else {
        dataToSend = {
          guest_token: document.querySelector('#project_template_guest_token').value,
          name: document.querySelector('#' + this.element.id + ' #project_template_name')?.value,
          tags: selectedTags,
          title: document.querySelector('#' + this.element.id + ' #project_template_title')?.value,
          description: document.querySelector('#' + this.element.id + ' #project_template_description')?.value,
          employee_count: document.querySelector('#' + this.element.id + ' #project_template_employee_count')?.value,
          year_founded: document.querySelector('#' + this.element.id + ' #project_template_year_founded')?.value,
          based: document.querySelector('#' + this.element.id + ' #project_template_based')?.value,
          website: website,
          form_name: event.target.attributes["data-form-name"].nodeValue,
          overall_look: document.querySelector('#' + this.element.id + ' #project_template_overall_look')?.value.replace(/(\r\n|\n|\r)/gm, " "),
          shops_experience: document.querySelector('#' + this.element.id + ' #project_template_shops_experience')?.type === "text" ?
              document.querySelector('#' + this.element.id + ' #project_template_shops_experience')?.value :
              document.querySelector('#' + this.element.id + ' .active input[name="project_template[shops_experience]"]')?.value,
          existing_shops_info: document.querySelector('#' + this.element.id + ' #project_template_existing_shops_info')?.value,
          popups_experience: document.querySelector('#' + this.element.id + ' #project_template_popups_experience')?.type === "text" ?
              document.querySelector('#' + this.element.id + ' #project_template_popups_experience')?.value :
              document.querySelector('#' + this.element.id + ' .active input[name="project_template[popups_experience]"]')?.value,
          industry: selectedIndustry,
          instagram_id: instagram,
          linkedin_id: linkedin,
          facebook_id: facebook,
          twitter_id: twitter,
          unit_id: document.querySelector('#' + this.element.id + ' #project_template_unit_id')?.value,
        };
      }
    }

    const fieldDescriptionHtmlCode = `
    <div class="flex flex-col field field-ai-description rounded bg-gray-150 m-0 p-4 animate-pulse">
      <div class="h-4 bg-gray-200 rounded w-full"></div>
      <div class="h-14 bg-gray-200 rounded w-full mt-3"></div>
    </div>`;

    const inputFieldsHtmlCode = `
    <div class="pt-4 animate-pulse">
      <div class="h-4 bg-gray-200 rounded w-1/5"></div>
      <div class="h-11 bg-gray-200 rounded w-full mt-1"></div>
      <div class="h-4 bg-gray-200 rounded w-1/3 mt-1"></div>
    </div>`;

    const textAreaHtmlCode = `
    <div class="pt-4 animate-pulse">
      <div class="h-4 bg-gray-200 rounded w-1/4"></div>
      <div class="h-24 bg-gray-200 rounded mt-1"></div>
      <div class="h-4 bg-gray-200 rounded w-1/3 mt-1"></div>
    </div>`;

    const buttonHtmlCode = `<div class="h-10 animate-btn bg-gray-200 rounded w-48 ml-4 mt-1"></div>`;
    const projectName = document.querySelector('#' + this.element.id + ' #project_template_name')?.value
    const projectTemplateId = document.querySelector('#' + this.element.id + ' #project_template_id')?.value

    $.ajax({
      url: action,
      type: method,
      dataType: "json",
      timeout: this.hasTimeoutValue ? this.timeoutValue : 29000,
      data: {
        project_template: dataToSend,
        form_name: formName,
        project_name: projectName,
        project_template_id: projectTemplateId,
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      beforeSend: function() {
        document.querySelector('.modal-content')?.scrollIntoView({behavior: 'smooth', block: 'start'})
        document.querySelector('.loader')?.classList.remove('is-hidden')
        const descriptionField = document.querySelector('.field.field-ai-description');
        const inputFields = document.querySelectorAll('.field.text');
        const textAreaFields = document.querySelectorAll('.field.text-area');
        const buttonFields = document.querySelectorAll('.submit-btn.animated');
        if (descriptionField) {
          descriptionField.style.display = 'none';
        }
        descriptionField?.insertAdjacentHTML('beforebegin', fieldDescriptionHtmlCode);
        inputFields?.forEach(field => {
          field.style.display = 'none';
          field.insertAdjacentHTML('beforebegin', inputFieldsHtmlCode);
        });
        textAreaFields?.forEach(field => {
          field.style.display = 'none';
          field.insertAdjacentHTML('beforebegin', textAreaHtmlCode);
        });
        buttonFields?.forEach(field => {
          field.style.display = 'none';
          field.insertAdjacentHTML('beforebegin', buttonHtmlCode);
        });
      }
    }).done((data) => {
      if (data?.project_template?.id) {
        let form = document.querySelector('#modal__global_new #project_template_form');
        if (form) {
          form.setAttribute("data-action", action.replace('pull_brand_data', data?.project_template?.id));
        }
      }

      if (data?.error) {
        alert(data?.error)
      }

      if (data?.logo?.files?.length > 0) {
        const logos = document.querySelectorAll('.logo-fileupload-brand-logo .preview');
        logos.forEach(logo => {
          if (!data.logo.files[0].url.includes('missing')) {
            logo.classList.remove('empty')
            logo.children[0]?.classList.remove('icon-photo')
            logo.nextElementSibling.children[0].style.display = 'none';
            logo.nextElementSibling.children[1].style.display = 'block';
            logo.style.backgroundImage = `url('${data.logo.files[0].url}')`;
          }
        })
      }

      if (data?.backgroundImage?.files?.length > 0) {
        const images = document.querySelectorAll('.logo-fileupload-brand-image .preview');
        images.forEach(image => {
          if (!data.backgroundImage.files[0].url.includes('missing')) {
            image.classList.remove('empty')
            image.children[0]?.classList.remove('icon-photo')
            image.nextElementSibling.children[0].style.display = 'none';
            image.nextElementSibling.children[1].style.display = 'block';
            image.style.backgroundImage = `url('${data.backgroundImage.files[0].url}')`;
          }
        })
      }

      if (data?.photos?.files?.length > 0) {
        let instagramUrlInputValue = document.getElementById('instagram_url')?.value
        let instagramIdInput = document.getElementById('project_template_instagram_id')
        if (instagramUrlInputValue && instagramIdInput) {
          instagramIdInput.value = instagramUrlInputValue;
        }

        function renderFiles(files) {
          files.forEach(file => {
            const fileDiv = document.createElement('div');
            let thumbnailUrl = file.thumbnailUrl.replace('attachments', 'brand_images');
            let attachmentTemplate = document.querySelector("#attachment-template-download")?.innerHTML;
            if (attachmentTemplate) {
              let tempContainer = document.createElement('div');
              tempContainer.innerHTML = attachmentTemplate;
              let Title = tempContainer.querySelector("input[name='description']")?.placeholder;
              let Update = tempContainer.querySelector('.btn.update span')?.innerText
              let Delete = tempContainer.querySelector('.btn.btn-danger span')?.innerText

              fileDiv.className = 'template-download in';
              fileDiv.setAttribute('data-id', file.id);

              fileDiv.innerHTML = `
              <div class="fileupload-preview grid-container col-gap-0-5">
                  <div class="preview grid-3">
                      <img src="${thumbnailUrl}" alt="${file.name}">
                  </div>
                  <div class="preview__data grid-9">
                      <div class="preview__options text-left">
                          <input required="required" minlength="3" class="input" placeholder="${Title}" name="description" value="${file.description ? file.description?.trim() : ''}">
                          <div class="description">${file.description ? file.description?.trim() : ''}</div>
                          <div class="size">${(file.size / 1024).toFixed(2)} KB</div>
                          <div>
                          <button class="btn btn-primary start" type="button" data-remote="true"
                             onclick="event.preventDefault(); 
                                      const description = this.closest('.template-download').querySelector('input')?.value?.trim();
                                      const description_label = this.closest('.template-download').querySelector('.description')
                                      const csrfToken = document.querySelector('meta[name=\\'csrf-token\\']').getAttribute('content');
                                      const data = new URLSearchParams();
                                      data.append('description', description);
                                      fetch('${file.updateUrl}', {
                                          method: 'PATCH',
                                          headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/x-www-form-urlencoded',
                                            'X-CSRF-Token': csrfToken
                                          },
                                          body: data.toString()
                                      }).then(() => {
                                          description_label.innerText = description;
                                        }).catch(error => console.error('Error:', error));">
                                <i class="icon-arrow-up">&nbsp;</i>
                                <span>${Update}</span>
                              </button>
                              <button class="btn btn-secondary btn-warning cancel" type="button" data-remote="true"
                                 onclick="event.preventDefault(); 
                                          const csrfToken = document.querySelector('meta[name=\\'csrf-token\\']').getAttribute('content');
                                          fetch('${file.deleteUrl}', { 
                                              method: 'DELETE',
                                              headers: {
                                                  'X-CSRF-Token': csrfToken
                                              }}).then(() => {
                                                  this.closest('.template-download').remove();
                                          })">
                                <i class="icon-trash-can">&nbsp;</i>
                                <span>${Delete}</span>
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
            `;
              const container = document.querySelector('#instagram_photos_holder');
              const elements = document.querySelectorAll('#project_template_photos #attachment_files .template-download');
              elements?.forEach(file => {
                file.remove();
              });

              if (container) {
                container.parentElement.classList.remove('d-none')
                container.appendChild(fileDiv);
                container.parentElement.scrollIntoView({behavior: 'smooth', block: 'start'});
              }
            }
          });
        }

        renderFiles(data.photos.files);
      }

      document.querySelector('.loader')?.classList.add('is-hidden')
      const fields = document.querySelectorAll('.field, .animated');
      const animated_elements = document.querySelectorAll('.animate-pulse, .animate-btn');
      fields?.forEach(field => {
        field.style.display = '';
      });
      animated_elements?.forEach(element => {
        element.remove()
      });
      if (data && data.errors) {
        this.showErrorNotifications(data.errors);
      } else {
        if (data && data.project_template && data.project_template.id !== null) {
          $('#modal__ai_project_template_create').on('hidden.bs.modal', function () {
            $(this).remove();
          }).modal('hide');

          let submitButtons = document.querySelectorAll('#modal__global_new .submit-btn')
          submitButtons.forEach(btn => {
            btn.setAttribute('data-project-template-id', data.project_template?.id);
          })
        }

        function findTemplateIdValue() {
          const buttons = document.querySelectorAll('.submit-btn');
          const templateIds = [];

          buttons.forEach(button => {
            let templateId = button.getAttribute('data-project-template-id');
            if (templateId) {
              templateIds.push(templateId);
            }
          });

          return templateIds[0];
        }

        let projectTemplateId = findTemplateIdValue();

        function clearAndSetTagsIndustry(selectFields, newValues) {
          selectFields.forEach(field => {
            $(field).val(newValues).trigger('change');
          })
        }

        function setExperience(baseSelector, experienceValue, experienceType) {
          if (experienceValue === "true" || experienceValue === "false") {
            $(`${baseSelector} #project_template_${experienceType}_${experienceValue}`).parent().addClass('active');
          }
        }

        function autofillForm(data, formName) {
          let baseSelector = '#modal__global_new'
          $(baseSelector).modal('show');
          let dataFormName = (formName === 'partial_new_ai' || formName === 'partial_pull_data_ai') ? 'full_new_ai' : 'global_new';
          let submitButton = document.querySelectorAll(`.submit-btn[data-form-name="global_new"], .submit-btn[data-form-name="full_new_ai"]`);

          submitButton.forEach(btn => {
            btn.attributes['data-form-name'].value = dataFormName
          })

          if (formName === 'partial_new_ai' || formName === 'partial_pull_data_ai') {
            document.querySelector('.field-description')?.classList.remove('is-hidden')
          } else {
            document.querySelector('.field-description')?.classList.add('is-hidden')
          }

          let FirstSection = document.querySelector(baseSelector + ' .section.collapse')
          FirstSection?.classList.add("show");

          function reinitializeUploadComponent(projectTemplateId) {
            let logoInputs = document.querySelectorAll('.logo-fileupload-brand-logo');
            let imageInputs = document.querySelectorAll('.logo-fileupload-brand-image');
            let imagesPhotos = document.querySelectorAll('#attachment-fileupload');

            const initializeFileUpload = (element, attributeName) => {
              let newUrl = element.getAttribute(attributeName).replace('-1', projectTemplateId);
              element.setAttribute(attributeName, newUrl);

              $(element).fileupload({
                url: newUrl,
                dataType: 'json',
                autoUpload: true,
                acceptFileTypes: /(\.|\/)(gif|jpe?g|png|bmp|tiff|webp)$/i,
                maxFileSize: 25000000
              });
            };

            logoInputs.forEach(logo => {
              initializeFileUpload(logo, 'data-logo-upload-url');
              let logoInputField = logo.querySelector('input');
              let logoInputFieldLabels = logo.querySelectorAll('label');
              let newIdLogoField = logo.querySelector('input').getAttribute('id').replace('-1', projectTemplateId);
              let logoNewIdLogoField = logo.getAttribute('id').replace('-1', projectTemplateId);
              let logoParentInputFieldLabel = logo.parentElement.querySelector('label');
              logo.setAttribute('id', logoNewIdLogoField);
              logoParentInputFieldLabel.setAttribute('for', newIdLogoField);
              logoInputField.setAttribute('data-project-template-id', projectTemplateId);
              logoInputField.setAttribute('name', newIdLogoField);
              logoInputField.setAttribute('id', newIdLogoField);
              logoInputFieldLabels.forEach( label => {
                label.setAttribute('for', newIdLogoField);
              })
          });

          imageInputs.forEach(image => {
              initializeFileUpload(image, 'data-logo-upload-url');
              let imageInputField = image.querySelector('input');
              let imagesInputFieldLabels = image.querySelectorAll('label');
              let newIdImageField = image.querySelector('input').getAttribute('id').replace('-1', projectTemplateId);
              let imageNewIdImageField = image.getAttribute('id').replace('-1', projectTemplateId);
              let imagParentInputFieldLabel = image.parentElement.querySelector('label');
              image.setAttribute('id', imageNewIdImageField);
              imagParentInputFieldLabel.setAttribute('for', imageNewIdImageField);
              imageInputField.setAttribute('data-project-template-id', projectTemplateId);
              imageInputField.setAttribute('name', newIdImageField);
              imageInputField.setAttribute('id', newIdImageField);
              imagesInputFieldLabels.forEach( label => {
                label.setAttribute('for', newIdImageField);
              })
          });

            imagesPhotos.forEach(photo => {
              let newUrl = photo.getAttribute('data-url')?.replace('-1', projectTemplateId);
              if (newUrl !== null) {
                photo.setAttribute('data-url', newUrl);

                $(photo).fileupload({
                  url: newUrl,
                  dataType: 'json',
                });
              }
            });
          }

          if (formName === 'partial_new_ai' || formName === 'partial_pull_data_ai' || formName === 'full_new_ai') {
            reinitializeUploadComponent(projectTemplateId)
          }

          let $tags = document.querySelectorAll("[name='project_template[tags][]']")
          let $industries = document.querySelectorAll("[name='project_template[industry][]']")

          clearAndSetTagsIndustry($tags, dataToSend.tags);
          clearAndSetTagsIndustry($industries, dataToSend.industry);

          setExperience(baseSelector, data.shops_experience, 'shops_experience');
          setExperience(baseSelector, data.popups_experience, 'popups_experience');

          const fields = [
            'title', 'description', 'name', 'employee_count', 'website', 'year_founded', 'based',
            'overall_look', 'existing_shops_info', 'instagram_id', 'linkedin_id', 'facebook_id', 'twitter_id'
          ];
          const fields_with_cents = [
            'prices_from_cents', 'prices_to_cents'
          ];

          fields.forEach(field => {
            $(`${baseSelector} #project_template_${field}`).val(data[field]).trigger('change');
          });

          fields_with_cents.forEach(field => {
            let element = document.querySelector(`${baseSelector} #project_template_${field.replace('_cents', '')}`)

            if (element) {
              const currency = element.dataset.currency?.toUpperCase();
              const decimalMark = element.dataset.decimalMark;
              const thousandsSeparator = element.dataset.thousandsSeparator;
              const initialValue = data[field] / 100;

              const anElement = new Autonumeric(element, {
                digitGroupSeparator: thousandsSeparator,
                decimalCharacter: decimalMark,
                currencySymbolPlacement: Autonumeric.options.currencySymbolPlacement.prefix,
                currencySymbol: `${currency} `,
                minimumValue: 0,
                decimalPlaces: 0
              });

              anElement.set(initialValue);
            }
          });
        }

        if (formName === "global_new") {
          if (window.location.pathname.includes('booking') || window.location.pathname.includes('cart')) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            const modal = document.querySelector('.modal.show');
            if (modal) {
              let button = modal.querySelector('.submit-btn');
              let EditProjectTemplateId = button.getAttribute('data-project-template-id');
              params.set('select_template_id', EditProjectTemplateId);
            }

            url.search = params.toString();

            window.history.replaceState(null, '', url.href);
            window.location.reload();
          }

          const redirect_path = document.querySelector('#' + this.element.id + ' .submit-btn').getAttribute('data-redirect-path');

          if (redirect_path === "edit") {
            Turbolinks.visit((window.location.pathname.endsWith('/') ? window.location.pathname : window.location.pathname + '/') + projectTemplateId + '/edit');
          }
        } else if (formName === "instagram_photos") {
        } else if (formName === "full_new_ai") {
          if (window.location.pathname.includes('booking') || window.location.pathname.includes('cart')) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            params.set('select_template_id', projectTemplateId);
            url.search = params.toString();

            window.history.replaceState(null, '', url.href);
            window.location.reload();
          }
          else {
            Turbolinks.visit((window.location.pathname.endsWith('/') ? window.location.pathname : window.location.pathname + '/') + projectTemplateId + '/edit');
          }
        } else if (formName === "minimal" || formName === "basic" || formName === "medium" || formName === "high") {
          if (window.location.pathname.includes('booking') || window.location.pathname.includes('cart')) {
            const modal = document.querySelector('.modal.show');
            if (modal) {
              let button = modal.querySelector('.submit-btn');
              let EditProjectTemplateId = button.getAttribute('data-project-template-id');
              const url = new URL(window.location.href);
              const params = new URLSearchParams(url.search);
              params.set('select_template_id', EditProjectTemplateId);
              url.search = params.toString();

              Turbolinks.visit(url.href, { action: "replace" });
              window.location.reload();
            }
          }
        }
        else if (formName === "partial_new" || formName === "partial_new_ai" || formName === "partial_pull_data_ai") {
          autofillForm(data.project_template, formName);
        }
        else if (window.location.pathname.includes('booking') || window.location.pathname.includes('cart')) {
          window.location.hash = '#booking-form-component';
          window.location.reload();
        }
        else {
          window.location.reload();
        }
      }
    }).fail(function(jqXHR, textStatus) {
      document.querySelector('.loader')?.classList.add('is-hidden')
      const fields = document.querySelectorAll('.field');
      const animated_elements = document.querySelectorAll('.animate-pulse, .animate-btn');
      fields?.forEach(field => {
        field.classList.remove('is-hidden')
      });
      animated_elements?.forEach(element => {
        element.remove()
      });
      if (textStatus === 'timeout') {
        const buttonFields = document.querySelectorAll('.submit-btn.animated');
        fields?.forEach(field => {
          field.style.display = '';
        });
        buttonFields?.forEach(field => {
          field.style.display = '';
        });
      }
    })
  }

  showErrorNotifications(errors) {
    document.querySelectorAll('#' + this.element.id + ' .modal__project_template .input__error').forEach((errorHolder) => {
      errorHolder.innerHTML = "";
      errorHolder.classList.add("is-hidden");
      const markDangerElements = errorHolder?.parentElement.querySelectorAll('.input, .select2-selection--single, .select2-selection--multiple');
      markDangerElements?.forEach(el => el.classList.remove('input__danger'));
    });

    document.querySelectorAll('#' + this.element.id + ' .modal__project_template .accordion-section').forEach((section) => {
      section.classList.remove("invalid");
    });

    Object.entries(errors).forEach((error) => {
      const fieldName = error[0];
      const errorMessage = error[1].join(', ');
      const errorHolder = document.querySelector('#' + this.element.id + ` #project_template_${fieldName}_error`);
      const section = document.querySelector('#' + this.element.id + ` .accordion-section.${errorHolder?.getAttribute("data-section")}`);
      section?.classList.add("invalid");
      errorHolder?.classList.remove("is-hidden");
      const markDangerElements = errorHolder?.parentElement.querySelectorAll('.input, .select2-selection--single, .select2-selection--multiple');
      markDangerElements?.forEach(el => el.classList.add('input__danger'));
      document.querySelectorAll('#' + this.element.id + ' #modal__global_new .collapse').forEach((section) => {
        section.classList.remove('show')
        section.parentElement.classList.add('collapsed')
      });
      if (section) {
        document.querySelector('#' + this.element.id + ' .invalid').parentElement.querySelector('.collapse').classList.add('show')
        document.querySelector('#' + this.element.id + ' .collapse').closest('form .collapse')?.classList.add('show')
      }
      errorHolder?.parentElement.parentElement.parentElement.classList.add("show");
      let closestElement = errorHolder?.closest('form .collapse');
      if (closestElement !== null) {
        errorHolder?.closest('form .collapse').classList.add("show");
      }
      if (errorHolder) {
        errorHolder.classList.remove("collapsed");
        errorHolder.parentElement.classList.remove("collapsed");
        errorHolder.innerHTML = errorMessage;
      }
      let first_error_input = document.querySelector('#' + this.element.id + ' .invalid');
      if (first_error_input !== null) {
        first_error_input.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    });
  }
}
